export default __webpack_public_path__ + "static/media/chat1.787368ba.png";